import { Link } from 'react-router-dom'
import { PageMessage } from '../components/PageMessage'

export function NotFoundPage() {
  return (
    <PageMessage title="Page not found" body="That page does not exist.">
      <Link to="/events">Back to events</Link>
    </PageMessage>
  )
}
